import React, { Component } from 'react'

class Notifications extends Component {
    render() {
        return (
            <div>
               <p>No Any Notification</p>
            </div>
        )
    }
}

export default Notifications 
